module.exports = __webpack_public_path__ + "img/数据一体化.de936f4a.png";